/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkLocation } from './WorkLocation';
export type TimeTrackingSessionSetWorkPackageEventBody = {
    action: TimeTrackingSessionSetWorkPackageEventBody.action;
    work_package_id: string;
    work_location: WorkLocation;
};
export namespace TimeTrackingSessionSetWorkPackageEventBody {
    export enum action {
        SESSION_SET_WORK_PACKAGE = 'session_set_work_package',
    }
}

